import Honeybadger from '@honeybadger-io/js';

import { RegistrationDialogueSeenSourceEvent } from './tracking/registrationDialogSeenSource';

export type Event = RegistrationDialogueSeenSourceEvent;

export const trackEvent = (event: Event) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (window.dataLayer === undefined) {
    Honeybadger.notify({
      message: 'Unable to track the event. DataLayer not found',
      fingerprint: 'google_analytics',
    });
    return;
  }
  window.dataLayer.push(event);
};
